import { useEffect, useState } from "react";
import { t as getFixedT } from "@/i18n";
import type { SupportedLanguage } from "@/lib/site";
import "./StickyCta.css";

interface StickyCtaProps {
  lang: SupportedLanguage;
}

/** Floating "تواصل معنا" CTA — 09-landing-page.md §2.1, mobile-only, appears once `#hero` scrolls
 * out of view. `IntersectionObserver`-driven (client-only; default/prerendered state is hidden —
 * never shows before JS hydrates, avoiding a layout flash). */
export function StickyCta({ lang }: StickyCtaProps) {
  const t = getFixedT(lang);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("hero");
    if (!hero || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { rootMargin: "-64px 0px 0px 0px" },
    );
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <a
      href="#lead-form"
      className={`fa-sticky-cta${visible ? " fa-sticky-cta--visible" : ""}`}
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      {t("stickyCta.label")}
    </a>
  );
}
